const HOME_PATH = '/';
const CLUB_HOME_PATH = '/:lang/club/:membership';
const COMMUNITIES_PATH = `${CLUB_HOME_PATH}/community` as const;
const COMMUNITY_PATH = `${COMMUNITIES_PATH}/:idCommunity` as const;
const COMMUNITY_POST_PATH = `${COMMUNITY_PATH}/post/:idPost` as const;
const COMMUNITY_SCHEDULED_POST_PATH = `${COMMUNITY_POST_PATH}/scheduled` as const;
const COMMUNITY_COLLABORATIVE_POST_PATH = `${COMMUNITY_POST_PATH}/collaborative` as const;
const SELECTED_MIGRATION_PATH = `${COMMUNITIES_PATH}/migration`;
const SINGLE_MIGRATION_PATH = `${COMMUNITY_PATH}/migration`;

export const paths = {
  HOME_PATH,
  CLUB_HOME_PATH,
  COMMUNITIES_PATH,
  COMMUNITY_PATH,
  COMMUNITY_POST_PATH,
  COMMUNITY_SCHEDULED_POST_PATH,
  COMMUNITY_COLLABORATIVE_POST_PATH,
  SELECTED_MIGRATION_PATH,
  SINGLE_MIGRATION_PATH
};
